import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";
import { ComponentActionTypes, VoyseComponent } from "@interfaces";
import { ComponentActionsService } from "../../services/component-actions.service";
import { ComponentMap, GridComponentMap } from "../component-map";

@Component({
    selector: "app-component-overlay",
    templateUrl: "./component-overlay.component.html",
    styleUrls: ["./component-overlay.component.css"],
    standalone: true,
    imports: [CommonModule],
})
export class ComponentOverlayComponent implements OnInit {
    @Input() component: VoyseComponent;
    @Input() editMode = false;
    @Input() componentIndex: number;
    @Input() rowIndex: number;
    @Input() gridIndex: number;
    @Input() isHeader = false;
    @Input() isFooter = false;
    @Input() isHighlighted = false;
    public componentMap = ComponentMap;

    constructor(protected actions: ComponentActionsService) {}

    public triggerEditComponent() {
        if (!this.isHeader && !this.isFooter) {
            this.actions.triggerComponentAction({
                action: ComponentActionTypes.EDIT_COMPONENT,
                componentIndex: this.componentIndex,
                rowIndex: this.rowIndex,
                gridIndex: this.gridIndex,
                componentData: this.gridIndex === null ? this.component : null,
                gridComponentData: this.gridIndex === null ? null : (this.component as any),
            });
        } else if (this.isHeader) {
            this.actions.triggerComponentAction({ action: ComponentActionTypes.HEADER_SELECTED });
        } else if (this.isFooter) {
            this.actions.triggerComponentAction({ action: ComponentActionTypes.FOOTER_SELECTED });
        }
    }

    ngOnInit(): void {
        if (this.gridIndex !== null && this.gridIndex !== undefined) {
            this.componentMap = GridComponentMap;
        }
    }
}
